const defaultValue = {};

const getFormValues = state => state.form && state.form.form && state.form.form.values || defaultValue;

export default {
    getFormValues
};
